export const HOTKEYS = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
  'mod+`': 'code',
};

export const RTE_HEADING_NODE_TYPES = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
} as const;

export const RTE_NODE_TYPES = {
  PARAGRAPH: 'paragraph',
  SPAN: 'span',
  ORDERED_LIST: 'ordered-list',
  UNORDERED_LIST: 'unordered-list',
  LIST_ITEM: 'list-item',
  LIST_ITEM_TEXT: 'list-item-text',
  BLOCKQUOTE: 'blockquote',
  ALIGN_LEFT: 'alignLeft',
  ALIGN_CENTER: 'alignCenter',
  ALIGN_RIGHT: 'alignRight',
  LINK: 'link',
  TABLE: 'table',
  TABLE_BODY: 'table-body',
  TABLE_ROW: 'table-row',
  TABLE_CELL: 'table-cell',
  TABLE_HEAD: 'table-head',
  IMAGE: 'image',
  HTML_CODE: 'html-code',
  ...RTE_HEADING_NODE_TYPES,
} as const;

export const FONT_FAMILIES = {
  sans: 'Helvetica,Arial, sans serif',
  serif: 'Georgia, Times New Roaman,serif',
  monospace: 'Monaco, Courier New,monospace',
} as const;
